export default __webpack_public_path__ + "static/media/content02.48e8bed3.png";